import { FailureActionPayload } from 'store/errors/types';
import { PaymentsConfig } from 'store/payments-config/types';
import { createAsyncAction } from 'typesafe-actions';

export const getPaymentsConfig = createAsyncAction(
  'GET_PAYMENTS_CONFIG_REQUEST',
  'GET_PAYMENTS_CONFIG_SUCCESS',
  'GET_PAYMENTS_CONFIG_FAILURE',
)<void, PaymentsConfig, FailureActionPayload>();
